module.exports = __webpack_public_path__ + "img/aadhar_card.c3555db5.png";